import { render, staticRenderFns } from "./service-category.vue?vue&type=template&id=45d77072&scoped=true"
import script from "./service-category.vue?vue&type=script&lang=ts"
export * from "./service-category.vue?vue&type=script&lang=ts"
import style0 from "./service-category.vue?vue&type=style&index=0&id=45d77072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d77072",
  null
  
)

export default component.exports